<template lang="pug">
.nav_tab.flex-shrink-0.flex-shrink-md-1.flex-grow-0.flex-md-grow-1(
  :class="{ selected: selected }"
)
  h5.text-center.i_body.i_ptb_2 {{ title }}
</template>

<script>
export default {
  name: "NavTab",
  props: {
    title: String,
    selected: Boolean,
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/nav_tab";
</style>
